// extracted by mini-css-extract-plugin
var _1 = "NodeV2Label_absolute__63b87";
var _2 = "NodeV2Label_active__7bcc7";
var _3 = "NodeV2Label_drag__52772";
var _4 = "NodeV2Label_flex__de78d";
var _5 = "NodeV2Label_grid__241e3";
var _6 = "NodeV2Label_hint__3ac67";
var _7 = "NodeV2Label_icon__f0c72";
var _8 = "NodeV2Label_item__666dc";
var _9 = "NodeV2Label_label__4cd5a";
var _a = "NodeV2Label_multiLabel__65eb6";
var _b = "NodeV2Label_root__bca2c";
var _c = "NodeV2Label_text__fca46";
var _d = "NodeV2Label_tooltip__ad907";
export { _1 as "absolute", _2 as "active", _3 as "drag", _4 as "flex", _5 as "grid", _6 as "hint", _7 as "icon", _8 as "item", _9 as "label", _a as "multiLabel", _b as "root", _c as "text", _d as "tooltip" }
